import types from '@/vuex/auth/mutations-types.js'

const mutations = {
  [types.SET_LOGGED_IN]: (state) => {
    state.logged = true
  },
  [types.UNSET_LOGGED_IN]: (state) => {
    state.logged = false
  },
  [types.SET_USERNAME]: (state, payload) => {
    state.username = payload.username
  },
  [types.UNSET_USERNAME]: (state) => {
    state.username = ''
  },
  [types.SET_NOME]: (state, payload) => {
    state.nome = payload.nome
  },
  [types.UNSET_NOME]: (state) => {
    state.nome = ''
  },
  [types.SET_VINCULO]: (state, payload) => {
    state.vinculo = payload.vinculo
  },
  [types.UNSET_VINCULO]: (state) => {
    state.vinculo = ''
  },
  [types.SET_ADMINISTRADOR]: (state, payload) => {
    state.administrador = payload.administrador
  },
  [types.UNSET_ADMINISTRADOR]: (state) => {
    state.administrador = false
  },
  [types.SET_USUARIO_PROEX]: (state, payload) => {
    state.usuarioPROEX = payload.usuarioPROEX
  },
  [types.UNSET_USUARIO_PROEX]: (state) => {
    state.usuarioPROEX = false
  },
  [types.SET_PERMISSAO_CRIAR_PROJETO_EXTENSAO]: (state, payload) => {
    state.permissaoCriarProjetoExtensao = payload.permissaoCriarProjetoExtensao
  },
  [types.UNSET_PERMISSAO_CRIAR_PROJETO_EXTENSAO]: (state) => {
    state.permissaoCriarProjetoExtensao = ''
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/vuex/auth/mutations.js